import React, { useContext, useEffect, useState } from 'react';

// @material-ui/core components

// core components
import GridContainer from '@components/Grid/GridContainer.js';
import GridItem from '@components/Grid/GridItem.js';

import OvsTable from '@components/ReactTable/OvsTable';
import { Column } from 'react-table';
import { itemTableData } from '../constants/itemTableData';
import { MessageGroupContext } from '../context/MessageGroupProvider';
import CardWrapper from '@components/Card/CardWrapper';
import { tableHeaderGen } from '@components/ReactTable/tableHeaderGen';
import TablePreview from '@components/Loaders/TablePreview';
import { itemFirmwareRoutes } from '../constants';

interface IRTable {
  title?: string;
  TableAction?: React.ReactNode;
  bulkDeleteProducts?: () => void;
}

const MessageGroupPage: React.FC<IRTable> = () => {
  const {
    items,
    getItems,
    loading,
    goTo,
    setSearchQuery,
    searchQuery,
    paging, setPageLimit
  } = useContext(MessageGroupContext);
  const [headers, setHeaders] = useState<Column[]>([]);
  useEffect(() => {
    getItems();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let tableGenHeader = tableHeaderGen(items[0])
    if (items.length > 0) {
      setHeaders([...itemTableData, ...tableGenHeader]);
    }
  }, [items]);

  if (headers.length === 0) {
    return <TablePreview items={items} loading={loading} />;
  }
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CardWrapper>
          <OvsTable
            columns={
              headers as Column[]
            }
            data={items}
            addItemPageLink={itemFirmwareRoutes.add}
            checkedIds={[]}
            isLoading={loading}
            paging={paging}
            goTo={goTo}
            setSearchQuery={setSearchQuery}
            searchQuery={searchQuery}
            setPageLimit={setPageLimit}
          />
        </CardWrapper>
      </GridItem>
    </GridContainer>
  );
};

export default MessageGroupPage;
